"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-Activity.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_attrs0 = {
        "class": "card item"
      },
    marko_attrs1 = {
        "class": "swiper-heading"
      },
    marko_attrs2 = {
        "class": "d-block blue-grey-text"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  route_link_tag({
      href: input.link,
      class: "d-flex align-items-center",
      renderBody: function(out) {
        out.e("i", {
            "class": marko_classValue("bx mr-1 py-2 px-2 font-weight-normal font-large-1 " + input.icon)
          }, "2", component, 0, 1);

        out.e("div", null, "3", component, 2)
          .e("div", marko_attrs1, "4", component, 1)
            .t(input.name, component)
          .e("small", marko_attrs2, "5", component, 1)
            .t(input.subject || input.status, component);
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
